import { GiftListItem } from '../../types/cmsProduct';
import { getHotRewardOverrideValue } from '../../utils/helpers/attrHelpers';
import { ComparisonTableProduct, RewardColumnClickInfo } from './types';

export const getGitsFromProduct = (
  product: ComparisonTableProduct,
): {
  offerUid: string;
  gift: GiftListItem;
} | null => {
  if (product.hot_reward) {
    return {
      offerUid: 'hot_reward_offerUid',
      gift: {
        id: 'hot_reward_id',
        gift: product.hot_reward,
      },
    };
  }
  const offers = [
    ...(product?.exclusive_offers ?? []),
    ...(product?.bundle_exclusive_offers ?? []),
    // ...(product?.welcome_offers ?? []),
  ].flatMap((offer) =>
    (offer?.list_of_gifts ?? []).map((gift) => ({
      gift,
      offerUid: offer?.uid,
    })),
  ) as { offerUid: string; gift: GiftListItem }[];

  const gifts = offers.map((offer) => offer).filter(Boolean);

  const mainGift = offers.find((o) => o.gift.main_gift);

  if (mainGift) {
    return mainGift;
  }

  gifts.sort(
    (a, b) =>
      Number(b?.gift?.gift?.gift_value?.price) -
      Number(a?.gift?.gift?.gift_value?.price),
  );

  return gifts?.[0] ?? null;
};

/**
 * Text-only override for the Hot Reward cell (CMS-1969): value, sorting and the
 * click target still read the gift relation, hence not in getGitsFromProduct.
 */
export const getHotRewardDisplayText = (
  product: ComparisonTableProduct,
): string | undefined =>
  getHotRewardOverrideValue(product) ??
  getGitsFromProduct(product)?.gift?.gift?.gift_title;

// CMS-authored strings carry the two-character `\n` sequence for line breaks.
const normalizeTrackingText = (text: string): string =>
  text.replace(/\\n/g, ' ').trim();

export const getTooltipComponentTitle = (
  header: string | undefined,
  fallback: string | null | undefined,
): string => {
  const attributeName = normalizeTrackingText(header ?? fallback ?? '');
  return attributeName
    ? `Product List/Tooltip_${attributeName}`
    : 'Product List/Tooltip';
};

export const getRewardColumnComponentTitle = ({
  columnTitle,
  clickText,
}: RewardColumnClickInfo): string =>
  `Product List/${normalizeTrackingText(columnTitle)}_${normalizeTrackingText(clickText)}`;
